module.exports = __webpack_public_path__ + "img/person2.9416a828.svg";